(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walk-and-glow"] && !Shopify.designMode) return;
  try {
    

function initialiseWalkGlowEvents() {

  const sections = document.querySelectorAll('[data-wg-events]');

  sections.forEach(function(section) {

    if (section.dataset.wgInitialised === 'true') {
      return;
    }

    section.dataset.wgInitialised = 'true';


    /* CAROUSEL */

    const slider = section.querySelector('[data-wg-slider]');
    const previousButton = section.querySelector('[data-wg-prev]');
    const nextButton = section.querySelector('[data-wg-next]');

    if (slider) {

      function getScrollAmount() {

        const firstCard = slider.querySelector('.wg-card');

        if (!firstCard) {
          return slider.clientWidth;
        }

        const styles = window.getComputedStyle(slider);

        const gap = parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        );

        return firstCard.getBoundingClientRect().width + gap;
      }


      function updateArrows() {

        const maxScroll =
          slider.scrollWidth -
          slider.clientWidth;

        const currentScroll =
          slider.scrollLeft;

        const hasOverflow =
          maxScroll > 5;


        if (previousButton) {

          previousButton.classList.toggle(
            'is-hidden',
            !hasOverflow
          );

          previousButton.disabled =
            currentScroll <= 5;

        }


        if (nextButton) {

          nextButton.classList.toggle(
            'is-hidden',
            !hasOverflow
          );

          nextButton.disabled =
            currentScroll >= maxScroll - 5;

        }

      }


      if (previousButton) {

        previousButton.addEventListener(
          'click',
          function() {

            slider.scrollBy({
              left: -getScrollAmount(),
              behavior: 'smooth'
            });

          }
        );

      }


      if (nextButton) {

        nextButton.addEventListener(
          'click',
          function() {

            slider.scrollBy({
              left: getScrollAmount(),
              behavior: 'smooth'
            });

          }
        );

      }


      slider.addEventListener(
        'scroll',
        updateArrows,
        { passive: true }
      );


      window.addEventListener(
        'resize',
        updateArrows
      );


      updateArrows();

    }


    /* POPUPS */

    const popupButtons =
      section.querySelectorAll(
        '[data-wg-popup-open]'
      );


    popupButtons.forEach(
      function(button) {

        button.addEventListener(
          'click',
          function() {

            const popupId =
              button.getAttribute(
                'data-wg-popup-open'
              );

            const popup =
              document.getElementById(
                popupId
              );

            if (popup) {
              popup.showModal();
            }

          }
        );

      }
    );


    const popups =
      section.querySelectorAll(
        '[data-wg-popup]'
      );


    popups.forEach(
      function(popup) {

        const closeButton =
          popup.querySelector(
            '[data-wg-popup-close]'
          );


        if (closeButton) {

          closeButton.addEventListener(
            'click',
            function() {
              popup.close();
            }
          );

        }


        popup.addEventListener(
          'click',
          function(event) {

            if (event.target === popup) {
              popup.close();
            }

          }
        );

      }
    );

  });

}


initialiseWalkGlowEvents();


document.addEventListener(
  'shopify:section:load',
  initialiseWalkGlowEvents
);


  } catch(e) { console.error(e); }
})();
})();
